import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation createSubjectOnBoardRemark(
    $data: createSubjectOnBoardRemarkInput!
  ) {
    createSubjectOnBoardRemark(data: $data) {
      id
      status
      error {
        message
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const createSubjectOnBoardRemarkRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.CreateSubjectOnBoardRemarkInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'subject_on_board_remark/create_subject_on_board_remark',
  async (
  params: {data: TYPES.CreateSubjectOnBoardRemarkInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.createSubjectOnBoardRemark;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const createSubjectOnBoardRemarkSlice = createSlice({
  name: 'create_subject_on_board_remark',
  initialState: initialState,
  reducers: {
    createSubjectOnBoardRemarkClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(createSubjectOnBoardRemarkRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      createSubjectOnBoardRemarkRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      createSubjectOnBoardRemarkRequest.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: 'Failed to fetch',
          statusCode: '500'
        };
        state.loading = false;
      }
    );
  }
});

export const { createSubjectOnBoardRemarkClear } =
createSubjectOnBoardRemarkSlice.actions;

export const createSubjectOnBoardRemark = createSelector(
  (state: RootState) =>
  state.subjectOnBoardRemark.createSubjectOnBoardRemark.result,
  (state: RootState) =>
  state.subjectOnBoardRemark.createSubjectOnBoardRemark.error,
  (state: RootState) =>
  state.subjectOnBoardRemark.createSubjectOnBoardRemark.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default createSubjectOnBoardRemarkSlice.reducer;